import { gql } from 'react-apollo';

export const updateChurchMemberGroup = gql`
  mutation updateChurchMemberGroup($input: UpdateChurchMemberGroupInput!) {
    updateChurchMemberGroup(input: $input) {
      churchMember: user {
        id
        group: church_group {
          id
          name
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/churchMembers/mutations/updateChurchMemberGroup.js